import React from "react";
import { useLocation } from "react-router-dom";

import styles from "./Navbar.module.css";
import { HomeNavbarWrapper } from "./ConditionalWrappers/NavbarWrappers";
import HomeNavbar from "./HomeNavbar/HomeNavbar";

const Navbar = () => {
  const location = useLocation();

  return (
    <>
      <div className={styles.separator}></div>
      <HomeNavbarWrapper location={location}>
        <HomeNavbar />
      </HomeNavbarWrapper>
    </>
  );
};

export default Navbar;
